(function () {
  'use strict';
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-leha-sort]')) return;
    event.target.closest('[data-leha-collection-form]')?.requestSubmit();
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const panel = event.target.closest('[data-leha-filter-panel][open]');
    if (!panel) return;
    panel.removeAttribute('open');
    panel.querySelector('summary').focus();
    event.preventDefault();
  });
})();
